
const digest = '6691bf6c19e97672cfdc9a758ae2e68983406e40370a9150c6be905a58b3a6eb';
const classes = {"wrapper":"_wrapper_8vzka_1","controls":"_controls_8vzka_8","list":"_list_8vzka_17"};
const css = `._wrapper_8vzka_1 {
  display: flex;
  flex-direction: column;
  font-family: Rubik, "sans-serif";
  height: 100%;
  gap: 10px;
}
._wrapper_8vzka_1 ._controls_8vzka_8 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  background-color: #ffffff;
  border: 1px solid #eaedf4;
  padding: 12px 24px;
  gap: 20px;
}
._wrapper_8vzka_1 ._list_8vzka_17 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  border: 1px solid #eaedf4;
  border-top: 0;
}
._wrapper_8vzka_1 ._list_8vzka_17::-webkit-scrollbar {
  display: block;
}
._wrapper_8vzka_1 ._list_8vzka_17::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._wrapper_8vzka_1 ._list_8vzka_17::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._wrapper_8vzka_1 ._list_8vzka_17::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._wrapper_8vzka_1 ._list_8vzka_17::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  